// src/components/AdminNavBar.jsx
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import "../assets/css/admin-dashboard.css";
import logo from "../assets/images/luth-logo-16x16.png";

export default function AdminNavBar() {
  const items = [
    { label: "Dashboard", to: "/dashboard" },
    { label: "Applicants", to: "/applicants" },
    { label: "Payments", to: "/applicants-payments" },
    { label: "Results", to: "/calculate-results" },
    // { label: "Registration", to: "/admin/register" },
    { label: "Reports", to: "/reports" },
    // { label: "Settings", to: "/settings" },
  ];

  const navigate = useNavigate();
  const handleLogout = () => navigate("/portal");

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-logo">
        <img src={logo} alt="Logo" className="admin-logo" />
        <span className="admin-navbar-brand">School Admin Portal</span>
      </div>

      <ul className="admin-navbar-menu">
        {items.map(({ label, to }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                isActive ? "active admin-nav-link" : "admin-nav-link"
              }
            >
              {label}
            </NavLink>
          </li>
        ))}

        {/* Logout button */}
        <li className="admin-nav-logout">
          <button onClick={handleLogout} className="admin-nav-link logout-btn">
            <FiLogOut />
          </button>
        </li>
      </ul>
    </nav>
  );
}
